import { AlertsProcessProps } from './props';
import { useAlertsProcess } from './hook';
import Loading from '../../../../../components/general/loadings/loading';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';

export const AlertsProcess = ({ alert, loading }: AlertsProcessProps) => {
    const { formik } = useAlertsProcess(alert);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Estado"
                    name="status"
                    size="small"
                    value={formik.values.status}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    value={formik.values.receptionChannel}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Tipo PQR"
                    name="typePQR"
                    size="small"
                    value={formik.values.typePQR}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Medio"
                    name="receivedThrough"
                    size="small"
                    value={formik.values.receivedThrough}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Subtipo DP"
                    name="subtypeDP"
                    size="small"
                    value={formik.values.subtypeDP}
                    onChange={console.log}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Tramite"
                    name="transaction"
                    size="small"
                    value={formik.values.transaction}
                    onChange={console.log}
                />
            </Grid>
        </Grid>
    );
};
